import { useLayoutEffect, useState } from "react";

import useTeacherSubjectGet from "@/teacher/hooks/useTeacherSubjectGet";
import useTeacherSubjectPost from "@/teacher/hooks/useTeacherSubjectPost";

const useTeacherSubjectMutation = (id) => {
  const initialResponse = useTeacherSubjectGet(id);
  const [postMethod] = useTeacherSubjectPost(id);
  const [response, setResponse] = useState(initialResponse);

  useLayoutEffect(() => {
    setResponse(initialResponse);
  }, [initialResponse]);

  const onMutationCallMiddleware = (mutationFn) => {
    return async (...args) => {
      setResponse((values) => ({ ...values, loading: true }));
      const response = await mutationFn(...args);
      setResponse((values) => ({ ...values, ...response, loading: false }));
      return response;
    };
  };

  return {
    response,
    postMethod: onMutationCallMiddleware(postMethod),
  };
};

export default useTeacherSubjectMutation;
